// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"592":"course","745":"learning"}[chunkId] + "." + {"592":"c7c3d436","745":"e47468c9"}[chunkId] + ".css";
};